import { useRecordContext } from "react-admin";
import { RecordMetaCard } from "../../layout";
import { fmtDateTimeDE } from "../components/raFormat";

export function JobMeta() {
  const r = useRecordContext<any>();
  if (!r) return null;

  return (
    <RecordMetaCard
      title="Systemdaten"
      rows={[
        {
          label: "Letztes Ereignis",
          value: r.lastEventAt ? fmtDateTimeDE(r.lastEventAt) : "—",
        },
        { label: "Erstellt", value: fmtDateTimeDE(r.createdAt) },
        { label: "Aktualisiert", value: fmtDateTimeDE(r.updatedAt) },
        { label: "Version", value: r.version ?? "—" },
      ]}
    />
  );
}
